import {
  applyFacetAccordionScrollStyle,
  clearFacetAccordionScrollStyle,
} from '../../utils/facetScrollStyles';

function bindFacetViewMoreOnce() {
  if (document.documentElement.dataset.facetViewMoreBound === 'true') {
    return;
  }
  document.documentElement.dataset.facetViewMoreBound = 'true';

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-facet-toggle-more]');
    if (!btn || !(btn instanceof HTMLButtonElement)) {
      return;
    }

    const root = btn.closest('[data-facet-list-root]');
    const more = root?.querySelector('[data-facet-more]');
    if (!more || !(more instanceof HTMLElement)) {
      return;
    }

    const expanding = btn.getAttribute('aria-expanded') !== 'true';

    more.hidden = !expanding;
    btn.setAttribute('aria-expanded', expanding ? 'true' : 'false');

    const collapsedLabel = root.querySelector('[data-facet-show-when-collapsed]');
    const expandedLabel = root.querySelector('[data-facet-show-when-expanded]');

    collapsedLabel?.classList.toggle('hidden', expanding);
    expandedLabel?.classList.toggle('hidden', !expanding);

    const scrollEl = btn.closest('[data-facet-list-scroll]');
    if (scrollEl != null) {
      if (expanding) {
        scrollEl.setAttribute('data-facet-scroll-expanded', '');
        applyFacetAccordionScrollStyle(scrollEl);
      } else {
        scrollEl.removeAttribute('data-facet-scroll-expanded');
        clearFacetAccordionScrollStyle(scrollEl);
      }
      scrollEl.scrollTop = 0;
    }
  });
}

export default function initFacetViewMore() {
  bindFacetViewMoreOnce();
}
